import { appendCardFilterParams } from 'store/services/cards/search/cardsSearchApi';
import { SearchRequestArgs } from 'screens/Main/Search/searchState';

export interface TradeHistoryQueryArgs {
  username: string;
  page?: number;
  limit?: number;
  tradeDirection?: 'all' | 'sent' | 'received';
  filters?: SearchRequestArgs;
}

/** The query string of GET /public/profile/:username/trade-history. */
export const buildTradeHistoryParams = ({ page = 1, limit = 20, tradeDirection, filters }: Omit<TradeHistoryQueryArgs, 'username'>): URLSearchParams => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (tradeDirection && tradeDirection !== 'all') params.append('tradeDirection', tradeDirection);
  // Card-attribute filters, in the one wire shape every list surface sends. The
  // backend returns a trade when any item matches and flags each item
  // (matchesFilters); the tab renders only the flagged ones.
  if (filters) appendCardFilterParams(params, filters);
  return params;
};
